import { render, staticRenderFns } from "./training_detail.vue?vue&type=template&id=65b710e7&"
import script from "./training_detail.vue?vue&type=script&lang=js&"
export * from "./training_detail.vue?vue&type=script&lang=js&"
import style0 from "./training_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports